// this file is generated from the root of the admin repo
// see https://github.com/tocktix/admin/wiki/Svg-Icons-Components in order to add a new file;
import * as React from "react";
import SvgIcon, { SvgIconProps } from "@material-ui/core/SvgIcon";

export const SvgIconBread = (props: SvgIconProps) =>
  React.createElement(
    SvgIcon,
    { width: "1em", height: "1em", viewBox: "0 0 24 24", ...props },
    <path d="M16 8.36L8 9.968V7.95l8-1.607zm-8 5.643l8-1.607v-2.019l-8 1.608zm0 4l8-1.607v-2.019l-8 1.608z" />,
    <path
      fillRule="evenodd"
      d="M18.679 3.016c-5.193-.945-8.155-.994-13.367.002l-.027.005-.027.007c-1.09.272-2.14.72-2.932 1.444C1.504 5.224 1 6.24 1 7.5c0 1.03.145 2.126.67 2.993a3 3 0 001.83 1.382V22h17V11.875a3 3 0 001.83-1.382c.525-.867.67-1.963.67-2.993 0-1.261-.504-2.275-1.326-3.026-.792-.723-1.842-1.172-2.931-1.444l-.032-.008zM3.674 5.951c.454-.414 1.144-.747 2.042-.974 4.921-.939 7.632-.896 12.572 0 .896.228 1.585.56 2.038.974.428.391.674.878.674 1.55 0 .902-.139 1.556-.38 1.956-.192.316-.481.543-1.12.543h-1v10h-13V10h-1c-.639 0-.928-.227-1.12-.543C3.14 9.057 3 8.403 3 7.5c0-.671.246-1.158.674-1.549"
    />
  );
export default SvgIconBread;
